// 用于显示用户出的题目，并标记是否审核通过
import problemUserSubmitDlg from './src/main.js'
export default problemUserSubmitDlg



// WEBPACK FOOTER //
// ./src/components/problemUserSubmitDlg/index.js